module.exports = __webpack_public_path__ + "img/8_college.9770abe5.png";